// extracted by mini-css-extract-plugin
module.exports = {"MediaSave":"MediaSave--3thYn","header":"header--1MszH","content":"content--2DXdC","wrap":"wrap--1Db-Y","tips":"tips--2ay6R"};